import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { SectionHeader } from '@/src/components/molecules';

const Story = props => {
  const { className, ...rest } = props;

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title="Nossa história"
        subtitle="Em 2017, nascemos com o propósito de tornar o relacionamento comercial e financeiro entre 
        instituições de ensino, fornecedores educacionais e seus alunos e responsáveis, algo simples 
        e descomplicado. Nossa plataforma tem como principal objetivo simplificar o 
        consumo de produtos e serviços educacionais, em qualquer lugar, a qualquer momento. 
        Nosso grande diferencial está em termos construído uma solução que é 100% aderente às 
        necessidades do setor educacional e todas as suas complexidades e particularidades."
        align={isMd ? 'center' : 'left'}
        disableGutter
        subtitleProps={{
          color: 'textPrimary',
          variant: 'body1',
        }}
      />
    </div>
  );
};

Story.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Story;
